/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Component, Inject, Input, OnInit } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CaseView } from '../../models/caseview.model';

export class Value {
  messages: null;
  msgDisplay: number;
  data: {
    classificationReason: null;
    customXidBean: null;
    dbSchema: null;
    empId: null;
    extendedVO: null;
    finalDecision: string;
    implicationFaced: string;
    initialRequest: null;
    langId: null;
    locId: null;
    recId: null;
  };
  errors: null;
}
@Component({
  selector: 'app-reason-for-disposing',
  templateUrl: './reason-for-disposing.component.html',
  styleUrls: ['./reason-for-disposing.component.scss'],
})
export class ReasonForDisposingComponent implements OnInit {
  response: string;
  value: Value;
  @Input() caseData: any;
  fileId: string;
  params = {};
  selectedData = [];
  constructor(
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (this.data[0]?.fileId) {
      this.caseData = this.data[0];
      this.fileId = String(
        this.caseData?.docId ? this.caseData?.docId : this.caseData?.fileId
      );
      console.log(this.caseData);
      let params = new HttpParams();
      params = params.append('recId', this.fileId);
      params = params.append('appTypeId', '1');
      this.params = params;
    } else {
      this.selectedData.push(this.data);
      console.log(this.selectedData);
      let params = new HttpParams();
      params = params.append(
        'recId',
        this.selectedData[0].selectedData[0].corrID
      );
      params = params.append('appTypeId', '3');
      this.params = params;
    }

    /* this.caseData = this.data[0];
    console.log('Data...', this.data[0]);
    this.fileId = String(
      this.caseData?.docId ? this.caseData?.docId : this.caseData?.fileId
    );
    console.log('file Id', this.fileId);
    let params = new HttpParams();
    params = params.append('recId', this.fileId); */
    this.http
      .get('/case-mgmnt/reason-for-disposing', { params: this.params })
      .subscribe((res: Value) => {
        this.value = res;
        this.response = this.value.data.finalDecision;
        console.log('Result :', this.value);
      });
  }

  ngOnInit(): void {
    console.log();
  }
}
